/**
 * Verified pod Drill cuts, per course (job #913). Each course's file in
 * ../data/podDrillCuts/ is EXPORTED by Popty tools/pods/pod-drill/stage.mjs (job #692; first written by the retired tools/pod-drill-cuts/run.mjs) and holds
 * ONLY the sentences whose cuts verified against their own recording; every
 * other sentence keeps playing whole. Loaded lazily, one small chunk per
 * course, so no course pays for another's cuts.
 */
import type { VerifiedDrillCut } from '@ssi/core/pods'

type CutFile = { sentences?: Record<string, VerifiedDrillCut> }

// Vite turns this into lazy imports at build time. Outside Vite (the esbuild-
// bundled read-only tools in tools/) import.meta.glob does not exist, and
// those tools see no cuts rather than failing.
let files: Record<string, () => Promise<CutFile>> = {}
try {
  files = import.meta.glob<CutFile>('../data/podDrillCuts/*.json', { import: 'default' })
} catch {
  files = {}
}

const loaded = new Map<string, Promise<Map<string, VerifiedDrillCut>>>()

/** The course's verified cuts by sentence id; an empty map when it has none
 *  or the file cannot be loaded (offline before it was ever fetched). */
export function loadDrillCuts(course: string): Promise<Map<string, VerifiedDrillCut>> {
  let p = loaded.get(course)
  if (!p) {
    const load = files[`../data/podDrillCuts/${course}.json`]
    p = load
      ? load().then((f) => new Map(Object.entries(f?.sentences || {}))).catch(() => {
        loaded.delete(course)
        return new Map()
      })
      : Promise.resolve(new Map())
    loaded.set(course, p)
  }
  return p
}
